// @ngInject
function CustomerGroupsApiService(ResourcesService) {

  var endpoint = 'customergroups';

  return {
    getCustomerGroups: ResourcesService.apiFactory.get(endpoint),
    getCustomerGroup: ResourcesService.apiFactory.get(endpoint),
    getLanguages: ResourcesService.apiFactory.get(endpoint + '/languages'),
    createCustomerGroup: ResourcesService.apiFactory.create(endpoint, 'CustomerGroup'),
    updateCustomerGroup: ResourcesService.apiFactory.update(endpoint, 'CustomerGroup'),
    deleteCustomerGroup: ResourcesService.apiFactory.delete(endpoint, 'CustomerGroup')
  };

}

angular
  .module('customergroups.api', [])
  .factory('CustomerGroupsApiService', CustomerGroupsApiService);
